module.exports = __webpack_public_path__ + "img/3Dian5_7.782884eb.png";